module.exports = __webpack_public_path__ + "img/avoid.3312a5b5.svg";